import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import MultiCheckboxGroup from '../../common/MultiCheckboxGroup';

const MultiCheckboxGroupComponent = () => {
    const options1 = ['Option 1', 'Option 2', 'Option 3'];
    const options2 = ['Apple', 'Banana', 'Cherry', 'Date'];
    const options3 = ['JavaScript', 'Python', 'Java', 'C++', 'Ruby'];

    const handleSelectionChange = (selectedOptions) => {
        console.log('Selected Options:', selectedOptions);
    };

    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Multi Checkbox Group Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <MultiCheckboxGroup
                                    label="Select Your Options"
                                    options={options1}
                                    required={true}
                                    onChange={handleSelectionChange}
                                    showHelp={true}
                                    helpText="Please select at least one option."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<MultiCheckboxGroup
    label="Select Your Options"
    options={['Option 1', 'Option 2', 'Option 3']}
    required={true}
    onChange={handleSelectionChange}
    showHelp={true}
    helpText="Please select at least one option."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <MultiCheckboxGroup
                                    label="Choose Fruits"
                                    options={options2}
                                    required={false}
                                    maxSelections={2}
                                    onChange={handleSelectionChange}
                                    showHelp={true}
                                    helpText="You can select up to 2 fruits."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<MultiCheckboxGroup
    label="Choose Fruits"
    options={['Apple', 'Banana', 'Cherry', 'Date']}
    required={false}
    maxSelections={2}
    onChange={handleSelectionChange}
    showHelp={true}
    helpText="You can select up to 2 fruits."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <MultiCheckboxGroup
                                    label="Select Programming Languages"
                                    options={options3}
                                    required={true}
                                    maxSelections={3}
                                    onChange={handleSelectionChange}
                                    customError="Please select programming languages."
                                    showHelp={false}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<MultiCheckboxGroup
    label="Select Programming Languages"
    options={['JavaScript', 'Python', 'Java', 'C++', 'Ruby']}
    required={true}
    maxSelections={3}
    onChange={handleSelectionChange}
    customError="Please select programming languages."
    showHelp={false}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <MultiCheckboxGroup
                                    label="Agree to Policies"
                                    options={['I agree to the terms', 'I agree to the privacy policy']}
                                    required={true}
                                    onChange={handleSelectionChange}
                                    layout="inline"
                                    showHelp={true}
                                    helpText="You must agree to the terms."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<MultiCheckboxGroup
    label="Agree to Policies"
    options={['I agree to the terms', 'I agree to the privacy policy']}
    required={true}
    onChange={handleSelectionChange}
    layout="inline"
    showHelp={true}
    helpText="You must agree to the terms."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default MultiCheckboxGroupComponent;
